import { LoadStatus } from '@evorait/pace-core';
import { Action, createReducer, on } from '@ngrx/store';
import {
    loadODataMeasurementToolsFailure,
    loadODataMeasurementToolsSuccess,
} from '../actions/measurement-tools.action';
import { MeasurementTools } from '../../types/measurement-tools';
import { initialMeasurementToolsState, MeasurementToolsState } from '../state/measurement-tools.state';

function updateMeasurementToolsReducer(
    state: Readonly<MeasurementToolsState>,
    props: { measurementTools: MeasurementTools[] },
): Readonly<MeasurementToolsState> {
    return {
        ...state,
        tools: props.measurementTools,
        toolsStatus: LoadStatus.Loaded,
    };
}

function measurementToolsFailedReducer(state: Readonly<MeasurementToolsState>): Readonly<MeasurementToolsState> {
    return {
        ...state,
        toolsStatus: LoadStatus.Error,
    };
}

const createMeasurementToolsReducer = createReducer(
    initialMeasurementToolsState,
    on(loadODataMeasurementToolsSuccess, updateMeasurementToolsReducer),
    on(loadODataMeasurementToolsFailure, measurementToolsFailedReducer),
);

export function measurementToolsReducer(
    state: Readonly<MeasurementToolsState>,
    action: Action,
): Readonly<MeasurementToolsState> {
    return createMeasurementToolsReducer(state, action);
}
